"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _customProps = require("../../utils/customProps");

var _MuiDialogActions = _interopRequireDefault(require("./components/MuiDialogActions/MuiDialogActions"));

var _MuiDialogTitle = _interopRequireDefault(require("./components/MuiDialogTitle/MuiDialogTitle"));

var _MuiDialogContent = _interopRequireDefault(require("./components/MuiDialogContent/MuiDialogContent"));

var _customComponents = require("../../utils/customComponents");

var MuiDialog = function MuiDialog(_ref) {
  var open = _ref.open,
      toggleDialog = _ref.toggleDialog,
      rootClass = _ref.rootClass,
      dialogTitle = _ref.dialogTitle,
      content = _ref.content;
  var components = {
    MuiDialogActions: _MuiDialogActions.default,
    MuiDialogTitle: _MuiDialogTitle.default,
    MuiDialogContent: _MuiDialogContent.default
  };

  var dialogStyles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var title = dialogTitle[0];
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    className: dialogStyles.root,
    open: open
  }, /*#__PURE__*/_react.default.createElement(_MuiDialogTitle.default, (0, _extends2.default)({}, title, {
    toggleDialog: toggleDialog
  })), content.map(function (component, key) {
    return (0, _customComponents.renderComponents)(components, component, key);
  }));
};

var _default = MuiDialog;
exports.default = _default;
MuiDialog.propTypes = {
  /** storyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** 'MuiDialogContent', 'MuiDialogActions' */
  content: function content(props, propName, componentName) {
    var components = ['MuiDialogContent', 'MuiDialogActions'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  },

  /** MuiDialogTitle Allowed maximum: 1 */
  dialogTitle: function dialogTitle(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['MuiDialogTitle'], 1);
  },

  /** passed down from parent component to hide or show Dialog */
  open: _propTypes.default.bool,

  /** passed down from parent component to hide or show Dialog */
  toggleDialog: _propTypes.default.func.isRequired
};
MuiDialog.defaultProps = {
  open: false,
  rootClass: [],
  dialogTitle: [],
  content: []
};